﻿import Swiper from 'swiper'
import { SwiperOptions } from 'swiper/types/swiper-options'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

const createNavigation = (carousel: HTMLElement) => {
    const navigation: HTMLElement = document.createElement('nav')
    navigation.classList.add('swiper-navigation')
    carousel.appendChild(navigation)

    const buttonPrev: HTMLButtonElement = document.createElement('button')
    buttonPrev.classList.add('swiper-navigation__button')
    buttonPrev.classList.add('swiper-navigation__button-prev')
    buttonPrev.ariaLabel = `{{js.swiper.navigation.slide.previous.aria-label}}`

    const buttonNext: HTMLButtonElement = document.createElement('button')
    buttonNext.classList.add('swiper-navigation__button')
    buttonNext.classList.add('swiper-navigation__button-next')
    buttonNext.ariaLabel = `{{js.swiper.navigation.slide.next.aria-label}}`

    navigation.appendChild(buttonPrev)
    navigation.appendChild(buttonNext)

    carousel.appendChild(navigation)
}

const createPagination = (carousel: HTMLElement) => {
    const pagination: HTMLElement = document.createElement('nav')
    pagination.classList.add('swiper-pagination')
    carousel.appendChild(pagination)
}

const createWrapper = (carousel: HTMLElement) => {
    const swiperWrapper = carousel.querySelector<HTMLDivElement>('.swiper-wrapper')
    if (!swiperWrapper) return
    const wrapper = document.createElement('div')
    wrapper.classList.add('swiper-wrapper-container')
    wrapper.appendChild(swiperWrapper)
    carousel.appendChild(wrapper)
}

const createCallToAction = (swiper: Swiper) => {
    const container = document.createElement('div')
    container.className = 'swiper-cta'

    const buttons = swiper.el.querySelectorAll<HTMLAnchorElement>('.swiper-slide.attrax-button')
    buttons.forEach((button) => {
        button.remove()
        button.classList.remove('swiper-slide')
        button.removeAttribute('style')
        button.removeAttribute('tabindex')
        button.href = button.href.toLowerCase()
        container.appendChild(button)
    })

    swiper.update()
    swiper.el.appendChild(container)
}

const createCarousel = (query: string, swiperOptions: SwiperOptions) => {
    const carousels = document.querySelectorAll<HTMLElement>(query)
    carousels.forEach((carousel) => {
        carousel.classList.add('swiper')
        
        const children = [...carousel.children]
        children.forEach((child) => {
            child.classList.add('swiper-slide')
        })

        if (swiperOptions.navigation !== false) {
            createNavigation(carousel)
            swiperOptions.navigation = {
                prevEl: '.swiper-navigation__button-prev',
                nextEl: '.swiper-navigation__button-next',
            }
        }

        if (swiperOptions.pagination !== false) {
            createPagination(carousel)
            swiperOptions.pagination = {
                el: '.swiper-pagination',
                clickable: true,
                bulletElement: 'button',
            }
        }

        const swiper = new Swiper(carousel, {
            modules: [ Navigation, Pagination, Autoplay ],
            createElements: true,
            watchOverflow: true,
            watchSlidesProgress: true,
            ...swiperOptions,
        })

        createWrapper(carousel)
    })
}

const createPostsCarousel = () => {
    createCarousel('.carousel-posts .attrax-list-widget__list--has-items', {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        breakpoints: {
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            1400: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },
        on: {
            init: (swiper) => {
                createCallToAction(swiper)
            }
        }
    })
}

const createPerksBannerCarousel = () => {
    createCarousel('.new-perks-banner-carousel', {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        pagination: true,
        loop: true,
    })
}

const createHomepageHeroCarousel = () => {
    createCarousel('.banner-home-hero', {
         slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        pagination: true,
        navigation: false,
        speed: 2500,
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
        },
        loop: true,
    })
}

const createRecruitersCarousel = () => {
    createCarousel('.banner-meet-our-recruiters', {
        slidesPerView: 1,
        spaceBetween: 40,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            981: {
                slidesPerView: 2.6,
            },
        },
    })
}

const createQuoteBannerCarousel = () => {
    createCarousel('.new-quote-banner', {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        pagination: true,
        loop: true,
    })
}

export const initialise = () => {
    createPostsCarousel()
    createPerksBannerCarousel()
    createHomepageHeroCarousel()
    createRecruitersCarousel()
    createQuoteBannerCarousel()
}